import { CardsGridSkeleton, PageHeader, RegionCargando, Skeleton } from "@/components/ui";

/** Encabezado de la galería de Reportería · compartido por la página y su skeleton. */
export const ENCABEZADO_REPORTERIA = {
  titulo: "Reportería",
  descripcion: "Elige un reporte listo y ajústalo, o crea el tuyo desde cero.",
} as const;

/**
 * Secciones de la galería en carga · «Reportes predefinidos» y «Mis plantillas»
 * (título de sección + rejilla de tarjetas) y, si puede crear, la franja de
 * «Crear reporte personalizado». Es la rama de carga de `ReporteriaInicio`.
 */
export function SeccionesReporteriaSkeleton({ puedeCrear }: { puedeCrear: boolean }) {
  return (
    <RegionCargando etiqueta="Cargando reportes…" className="flex flex-col gap-6">
      {[6, 3].map((tarjetas, i) => (
        <section key={i} className="flex flex-col gap-3" aria-hidden="true">
          <div className="flex items-center gap-2">
            <Skeleton height={18} width={18} />
            <Skeleton height={14} width={i === 0 ? 170 : 120} />
          </div>
          <CardsGridSkeleton tarjetas={tarjetas} anunciar={false} />
        </section>
      ))}
      {puedeCrear && <Skeleton height={74} className="rounded-lg" aria-hidden="true" />}
    </RegionCargando>
  );
}

/**
 * Página de inicio de Reportería en carga (mientras llega el catálogo) · mismo
 * contenedor y encabezado que `ReporteriaInicio`, con sus secciones en skeleton.
 */
export function ReporteriaInicioSkeleton({ puedeCrear }: { puedeCrear: boolean }) {
  return (
    <div className="mx-auto flex max-w-6xl flex-col gap-6 p-4 md:p-6">
      <div className="flex flex-wrap items-end justify-between gap-3">
        <PageHeader title={ENCABEZADO_REPORTERIA.titulo} description={ENCABEZADO_REPORTERIA.descripcion} />
        <div className="flex flex-wrap gap-2" aria-hidden="true">
          <Skeleton height={36} width={170} />
          {puedeCrear && <Skeleton height={36} width={215} />}
        </div>
      </div>
      <SeccionesReporteriaSkeleton puedeCrear={puedeCrear} />
    </div>
  );
}
